import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * LocalBusiness JSON-LD — multi-zone targeting (Verviers · Liège · Narbonne).
 * Injects structured data so Google can show FACOW360 in local results across
 * Belgium (Verviers/Liège) and France (Narbonne).
 */
export const LocalBusinessJsonLd = () => {
  const data = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "@id": "https://facow360.com/#business",
    "name": "FACOW360 — Fabrice Marini",
    "alternateName": "FACOW360",
    "description":
      "FACOW360 — Méthode et accompagnement Fabrice Marini : géobiologie de l'habitat, magnétisme, cuisine vivante. Expertises et séances à Verviers, Liège (Belgique) et Narbonne (France), déplacements Europe sur demande.",
    "url": "https://facow360.com",
    "image": "https://facow360.com/og-cover.jpg",
    "logo": "https://facow360.com/logo.svg",
    "founder": { "@type": "Person", "name": "Fabrice Marini" },
    "knowsAbout": [
      "Géobiologie",
      "Géobiologie de l'habitat",
      "Magnétisme",
      "Cuisine Vivante",
      "Naturopathie",
      "Ayurvéda",
      "Chronobiologie",
      "Réseaux Hartmann et Curry",
      "Harmonisation des lieux"
    ],
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "20 quai de Lorraine",
      "postalCode": "11100",
      "addressLocality": "Narbonne",
      "addressRegion": "Occitanie",
      "addressCountry": "FR"
    },
    "areaServed": [
      {
        "@type": "City",
        "name": "Verviers",
        "address": { "@type": "PostalAddress", "addressCountry": "BE", "addressRegion": "Liège" }
      },
      {
        "@type": "City",
        "name": "Liège",
        "address": { "@type": "PostalAddress", "addressCountry": "BE", "addressRegion": "Liège" }
      },
      {
        "@type": "City",
        "name": "Narbonne",
        "address": { "@type": "PostalAddress", "addressCountry": "FR", "addressRegion": "Occitanie" }
      },
      { "@type": "Place", "name": "Europe — déplacements sur demande" }
    ],
    "serviceArea": [
      { "@type": "Country", "name": "Belgique" },
      { "@type": "Country", "name": "France" },
      { "@type": "Place", "name": "Europe" }
    ],
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "availableLanguage": ["French", "English"],
        "url": "https://wa.me/32498737919"
      }
    ],
    "sameAs": [
      "https://www.resalib.fr/praticien/129654-fabrice-marini",
      "https://wa.me/32498737919"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Méthode FACOW360",
      "itemListElement": [
        {
          "@type": "Offer",
          "name": "Géobiologie — Étude Maison",
          "price": "369",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer",
          "name": "Magnétisme — Régénération Énergétique",
          "price": "63",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer",
          "name": "Atelier Cuisine Vivante : Immersion Totale",
          "price": "108",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer",
          "name": "Bilan de Vitalité Alimentaire",
          "price": "21",
          "priceCurrency": "EUR"
        }
      ]
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};
